import { TeamNetRatingChart } from "./TeamNetRatingChart";
import { Flex, Text } from "@suns/design-system";
import { TeamPpvChart } from "./TeamTpvChart";
import { TeamRow } from "@suns/api/generated-client/apollo";
import { TeamTrvChart } from "./TeamTrvChart";

export function TeamAnalytics({ team }: { team: TeamRow }) {
  if (!team.metadata.length) {
    return (
      <Text heading muted size="lg" className="py-4 text-center">
        No analytic data available.
      </Text>
    );
  }

  return (
    <Flex direction="down" gap="lg">
      <Flex gap="lg" className="flex-col md:flex-row">
        <TeamNetRatingChart teamMetadata={team.metadata} />
        <TeamPpvChart teamMetadata={team.metadata} />
      </Flex>
      <Flex gap="lg" className="flex-col md:flex-row">
        <TeamTrvChart team={team} />
      </Flex>
    </Flex>
  );
}
